import React, { useState } from "react";
import { useData } from "@/context/DataContext";
import { PageTitle, Fab, RowActions, EmptyState } from "@/components/shared";
import DataDialog from "@/components/DataDialog";
import { formatDate } from "@/lib/format";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";

export default function Todo() {
  const { data, create, update, remove } = useData();
  const items = data.todo || [];
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const today = new Date().toISOString().slice(0, 10);

  const sorted = [...items].sort((a, b) => (a.target || "").localeCompare(b.target || ""));

  const fields = [
    { name: "task", label: "Task", type: "text", required: true },
    { name: "detail", label: "Detail Task", type: "textarea" },
    { name: "notes", label: "Notes Task", type: "textarea" },
    { name: "target", label: "Target Tanggal", type: "date", required: true },
  ];

  const onSave = async (payload) => {
    if (editing) { await update("todo", editing.id, payload); toast.success("Diperbarui"); }
    else { await create("todo", { ...payload, done: false, achieved: "" }); toast.success("Ditambahkan"); }
  };

  const toggle = async (i, checked) => {
    await update("todo", i.id, { done: checked, achieved: checked ? today : "" });
  };

  return (
    <div>
      <PageTitle title="To Do List" subtitle="Diurutkan berdasarkan target tanggal" />
      <div className="rounded-xl border border-border">
        <Table>
          <TableHeader><TableRow>
            <TableHead className="w-10"></TableHead><TableHead>Task</TableHead><TableHead>Detail</TableHead>
            <TableHead>Notes</TableHead><TableHead>Target</TableHead><TableHead>Selesai</TableHead>
            <TableHead className="text-right">Aksi</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {sorted.map((i) => {
              const overdue = !i.done && i.target && i.target < today;
              return (
                <TableRow key={i.id} data-testid={`row-${i.id}`} className={i.done ? "bg-green-500/15" : overdue ? "bg-red-500/15" : ""}>
                  <TableCell><Checkbox data-testid={`check-${i.id}`} checked={!!i.done} onCheckedChange={(v) => toggle(i, !!v)} /></TableCell>
                  <TableCell className="font-medium">{i.task}</TableCell>
                  <TableCell className="max-w-[160px] truncate text-muted-foreground">{i.detail || "-"}</TableCell>
                  <TableCell className="max-w-[160px] truncate text-muted-foreground">{i.notes || "-"}</TableCell>
                  <TableCell>{formatDate(i.target)}</TableCell>
                  <TableCell>{i.achieved ? formatDate(i.achieved) : "-"}</TableCell>
                  <TableCell><RowActions id={i.id} onEdit={() => { setEditing(i); setOpen(true); }} onDelete={() => remove("todo", i.id)} /></TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {items.length === 0 && <EmptyState />}
      </div>
      <Fab testId="fab-todo" onClick={() => { setEditing(null); setOpen(true); }} />
      <DataDialog open={open} onOpenChange={setOpen} title={editing ? "Edit Task" : "Tambah Task"} fields={fields} initial={editing} onSave={onSave} />
    </div>
  );
}
